import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert } from "reactstrap";

import React from "react";
import Loader from "../../common/Loader";

export const isIterableArray = (array) =>
  Array.isArray(array) && !!array.length;

export const PreloadState = ({
  loading,
  cond,
  children,
  loadingClass,
  message,
  overlay = false,
}) => {
  if (overlay) {
    return (
      <div style={{ position: "relative" }}>
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader className={`${loadingClass && loadingClass}`} />
            {message && <h6 className="text-center mt-2">{message}</h6>}
          </div>
        )}
        {children && isIterableArray(children)
          ? children.map(
            (child) =>
              (child.props.value === cond ||
                child.props.value === undefined) &&
              child
          )
          : children}
      </div>
    );
  }

  return loading ? (
    <div className={`${!loadingClass && "my-5"}`}>
      <Loader className={`${loadingClass && loadingClass}`} />
      {message && <h6 className="text-center">{message}</h6>}
    </div>
  ) : (
    <>
      {children && isIterableArray(children)
        ? children.map(
          (child) =>
            (child.props.value === cond || child.props.value === undefined) &&
            child
        )
        : children}
    </>
  );
};

export const Or = ({ cond, children }) =>
  children && isIterableArray(children)
    ? children.map(
      (child) =>
        (child.props.value === cond || child.props.value === undefined) &&
        child
    )
    : children;

export const If = ({ cond, children }) =>
  children &&
  (isIterableArray(children)
    ? children.map((child) => cond.indexOf(child.props.value) !== -1 && child)
    : cond.indexOf(children.props.value) !== -1 && children);

export const Message = ({
  tag,
  onClick,
  cond,
  children,
  className,
  icon,
  fontSize,
  align = "center",
  color = "transparent",
}) => (
  <Alert
    tag={tag}
    onClick={onClick}
    color={color}
    className={`m-0 d-flex w-100 justify-content-${align} align-items-center animated fadeIn ${className ? className : "py-5"
      } `}
  >
    <span style={{ fontSize: fontSize || 16, textAlign: "center" }}>
      {typeof icon === "string" ? (
        <em className={`icon ni ni-${!!icon ? icon : "info"} m-0 mr-1`} />
      ) : (
        <FontAwesomeIcon className="m-0 mr-1" icon={icon} />
      )}
      {children ? (
        <Or cond={cond}>{children}</Or>
      ) : (
        <>No hay datos para mostrar</>
      )}
    </span>
  </Alert>
);
